"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outcome = void 0;
var outcome_type_1 = require("./outcome-type");
var properties_maker_1 = require("../util/properties-maker");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var Outcome = /** @class */ (function () {
    function Outcome(outcome) {
        this.validateConstructorArg(outcome);
        this.type = outcome.type;
        this.params = outcome.params;
        this.reason = outcome.reason || '';
        this.adId = outcome.adId;
    }
    Outcome.prototype.validateConstructorArg = function (arg) {
        var prefix = 'Outcome creation: ';
        if (!arg.type || !outcome_type_1.OutcomeType[arg.type]) {
            throw new advanced_logic_error_1.AdvancedLogicError(prefix + 'type is not valid. Given:' + arg.type);
        }
    };
    Outcome.buildFrom = function (src, props) {
        return new Outcome(properties_maker_1.PropertiesMaker.merge(src, props));
    };
    Outcome.fromOutcomeResult = function (outcomeResult) {
        return new Outcome(outcomeResult.outcome);
    };
    return Outcome;
}());
exports.Outcome = Outcome;
